import type { Destinations as DestinationsData } from "@/queries/getDestinations";
import { useStore } from "@nanostores/react";
import { type ReactNode, useCallback, useEffect, useRef, useState } from "react";
import { Menu } from "./Menu";
import { MenuInner, menuStore } from "./MenuInner";
import { SMGDestinations } from "./SMGdestinations";
import { SMGIdeas } from "./SMGideas";

type Props = {
  destinations: DestinationsData;
  isHeaderTransparent: boolean;
  catalogueImage: ReactNode;
  isHomepage?: boolean;
};
export const SMGNavigationMenu = ({ destinations, isHeaderTransparent, catalogueImage, isHomepage = false }: Props) => {
  const openMenu = useStore(menuStore);
  const ref = useRef<HTMLDivElement>(null);
  const [right, setRight] = useState(0);
  const [left, setLeft] = useState(0);
  const isOpen = openMenu !== null;

  const handleResize = useCallback(() => {
    const { right, left } = ref.current?.getBoundingClientRect() || {};
    setRight(document.body.scrollWidth - (right || 0));
    setLeft(left || 0);
  }, []);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  return (
    <div ref={ref} className="h-20 flex gap-4" onMouseLeave={() => menuStore.set(null)}>
      <Menu menu="destinations" title="Destinations" isHeaderTransparent={isHeaderTransparent}>
        <SMGDestinations destinations={destinations} catalogueImage={catalogueImage} />
      </Menu>
      <Menu menu="inspirations" title="Thématiques" isHeaderTransparent={isHeaderTransparent}>
        <SMGIdeas catalogueImage={catalogueImage} />
      </Menu>
      {isOpen && (
        <>
          <div
            className="absolute left-0 top-10 h-10"
            style={{ clipPath: "polygon(100% 0, 0 100%, 100% 100%)", width: `${left}px` }}
          />
          <div
            className="absolute right-0 top-10 h-10"
            style={{ clipPath: "polygon(0 0, 0 100%, 100% 100%)", width: `${right}px` }}
          />
        </>
      )}
      <MenuInner isHomepage={isHomepage} />
    </div>
  );
};
